export const tableData = [{
    userID: 1,
    userNick: '昵称',
    thirdNick: "昵称",
    head: "http://thirdqq.qlogo.cn/qqapp/101517760/E0FEB0B493CE812E9CE70B2691681D23/40"
},{
    userID: 1,
    userNick: '昵称',
    thirdNick: "昵称",
    head: "http://thirdqq.qlogo.cn/qqapp/101517760/E0FEB0B493CE812E9CE70B2691681D23/40"
},{
    userID: 1,
    userNick: '昵称',
    thirdNick: "昵称",
    head: "http://thirdqq.qlogo.cn/qqapp/101517760/E0FEB0B493CE812E9CE70B2691681D23/40"
},{
    userID: 1,
    userNick: '昵称',
    thirdNick: "昵称",
    head: "http://thirdqq.qlogo.cn/qqapp/101517760/E0FEB0B493CE812E9CE70B2691681D23/40"
},{
    userID: 1,
    userNick: '昵称',
    thirdNick: "昵称",
    head: "http://thirdqq.qlogo.cn/qqapp/101517760/E0FEB0B493CE812E9CE70B2691681D23/40"
}]